import styles from './ButtonsQuestion.module.css' 
import Button, { ButtonKind, ButtonSize } from "@/components/UI/Buttons/Button/Button"
import { SurveyAction, SurveyActionTypes, SurveyButton, SurveyButtonsQuestion } from "@/interfaces/survey_types"
import { useModalStore } from '@/stores/useModalStore'
import { useSurveyStore } from '@/stores/useSurveyStore'
import { validateConditionsSurvey } from '@/utils/validators'

interface ButtonsQuestionProps extends React.ComponentProps<'div'> {
  data: SurveyButtonsQuestion
  submit: () => void
}

export default function ButtonsQuestion ({ data, submit, ...rest }: ButtonsQuestionProps) {
  const { fields, history, isPending, setStep, previousStep, setField, reset } = useSurveyStore()
  const { closeModal } = useModalStore()

  /**
   * Executes a list of survey actions based on their type
   * 
   * @param actions List of actions to process
   * @returns void
   */
  function handleActions (actions: SurveyAction[] | undefined) {
    if (!actions) return

    const isSubmitBtn = actions.some(elem => elem.action === SurveyActionTypes.SUBMIT)

    actions.forEach(action => {
      switch (action.action) {
        case SurveyActionTypes.EXIT:
          if(!isSubmitBtn) {
            reset()
            closeModal()
          }
          break
        case SurveyActionTypes.SUBMIT:
          // The exit action will be performed after the submit in the specified mutate
          submit()
          break
        case SurveyActionTypes.FIELD_SET:
          const isValid = validateConditionsSurvey(action.if, fields)
          if (isValid) setField(action.field, action.value)
          break
        case SurveyActionTypes.GO_TO:
          setStep(action.to)
          break
        case SurveyActionTypes.HISTORY_BACK:
          if (history.length <= 1) closeModal()
          else previousStep()
          break
      }
    })
  }

  return (
    <div className={styles.buttonsWrapper} {...rest}>
      {data.buttons.map((btn: SurveyButton, i: number) => {
        let kindBtn: ButtonKind
        switch (btn.style) {
          case 'secondary':
            kindBtn = ButtonKind.SECONDARY
            break
      
          default:
            kindBtn = ButtonKind.PRIMARY
            break
        }

        const IsValid = validateConditionsSurvey(btn['enable-if'], fields)

        return (
          <Button key={i} kind={kindBtn} size={ButtonSize.MEDIUM}
            type={'button'}
            disabled={!IsValid || isPending}
            onClick={() => handleActions(btn.actions)}
          >
            {btn.title}
          </Button>
        )
      })}
    </div>
  )
}